//@flow
import type { AppState } from '../../core/types'
import {
  getCommunicationState,
  COMM_STATES
} from '../../modules/communication/index'
import { CONNECT_CHARITY_RESOURCE } from './constants'
import { createSelector } from 'reselect'

export const getCharityConnectStatus = (state: AppState) =>
  getCommunicationState(CONNECT_CHARITY_RESOURCE, state)

export const isCharityConnectedOK = createSelector(
  getCharityConnectStatus,
  commState => commState === COMM_STATES.Success
)

export const isCharityConnectedFailed = createSelector(
  getCharityConnectStatus,
  commState => commState === COMM_STATES.Failure
)

export const isCharityConnecting = createSelector(
  getCharityConnectStatus,
  commState => commState === COMM_STATES.Loading
)



// WEBPACK FOOTER //
// ./src/services/stripe/selectors.js